__turbopack_context__.v({
  "faqActivePanelItem": "faqPanel-module-scss-module__ExJi9a__faqActivePanelItem",
  "faqPanelGroup": "faqPanel-module-scss-module__ExJi9a__faqPanelGroup",
  "faqPanelItem": "faqPanel-module-scss-module__ExJi9a__faqPanelItem",
  "faqPanelItemArrow": "faqPanel-module-scss-module__ExJi9a__faqPanelItemArrow",
  "faqPanelItemContent": "faqPanel-module-scss-module__ExJi9a__faqPanelItemContent",
  "faqPanelItemHeader": "faqPanel-module-scss-module__ExJi9a__faqPanelItemHeader",
  "header": "faqPanel-module-scss-module__ExJi9a__header",
  "headerTitle": "faqPanel-module-scss-module__ExJi9a__headerTitle",
  "panelContainer": "faqPanel-module-scss-module__ExJi9a__panelContainer",
});
